import * as Flashphoner from '@flashphoner/websdk';

import * as FPUtils from './fp-utils';

const STREAM_STATUS = Flashphoner.constants.STREAM_STATUS;
const Browser = Flashphoner.Browser;
const PRELOADER_URL = process.env.PUBLIC_URL + '/media/preloader.mp4';

export const VIEWER_PREFIX = 'viewer__';
export const isViewerName = (name: string) => name.startsWith(VIEWER_PREFIX);

/**
 * 화면에 표시하지 않는 오디오 전용 스트림(viewer__ 음성) 재생 관리.
 * 참가자 이름을 키로 재생 중인 스트림을 보관하고, LEFT / 방 나가기 시 정리한다.
 * 재생 컨테이너는 DOM에 붙이지 않은 div 를 사용한다 (RescuePage.playParticipantsStream 과 동일 방식).
 */
export class HiddenAudioPlayer {
  private streams = new Map<string, any>();

  play(participant: any) {
    const name: string = participant.name();
    if (this.streams.has(name)) return;
    const streams = participant.getStreams();
    if (streams.length === 0) return;

    const container = document.createElement('div');
    const start = () => {
      // playFirstVideo 대기 중 stop() 된 경우
      if (!this.streams.has(name)) return;
      const stream = streams[0]
        .play(container)
        .on(STREAM_STATUS.STOPPED, () => this.streams.delete(name))
        .on(STREAM_STATUS.FAILED, () => this.streams.delete(name));
      this.streams.set(name, stream);
    };
    // 재생 예약을 먼저 기록해 Safari playFirstVideo 대기 중 중복 play 를 막는다
    this.streams.set(name, null);
    if (Browser.isSafariWebRTC()) {
      Flashphoner.playFirstVideo(container, false, PRELOADER_URL).then(start);
    } else {
      start();
    }
  }

  stop(name: string) {
    const stream = this.streams.get(name);
    this.streams.delete(name);
    if (stream && FPUtils.isPlaying(stream.status())) {
      try {
        stream.stop();
      } catch (error) {
        //
      }
    }
  }

  stopAll() {
    Array.from(this.streams.keys()).forEach((name) => this.stop(name));
  }
}
